import styled from '@emotion/styled'
import { CartItem } from '@open-tender/types'
import RecommendationItem from './RecommendationItem'
import { useMemo } from 'react'
import { useMenuFilters } from 'utils/helpers'

const ItemsContainer = styled.div`
  label: UpsellItemsContainer;
  flex-grow: 0;
  display: block;
  justify-content: center;
  overflow-x: auto;
`

const ItemsView = styled.div`
  display: inline-flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
`

const ItemCol = styled.div<{ isSmall: boolean }>`
  flex-shrink: 0;
  width: ${(props) => (props.isSmall ? '22rem' : '30rem')};
  padding: 1.5rem 0;
  margin-right: 2rem;

  &:first-of-type {
    margin-left: 2rem;
  }

  & > div {
    height: 100%;
  }
`

const RecommendationItems = ({
  upsellItems,
  isSmall = false,
  addCallback,
  onItemClicked,
}: {
  upsellItems: CartItem[]
  isSmall?: boolean
  addCallback?: () => void
  onItemClicked?: (itemId: number, itemRank: number) => void
}) => {
  const { filterItems } = useMenuFilters()
  const items = useMemo(
    () => filterItems(upsellItems),
    [upsellItems, filterItems]
  )
  if (!items.length) return null

  return (
    <ItemsContainer>
      <ItemsView>
        {items.map((item, index) => (
          <ItemCol key={item.id} isSmall={isSmall}>
            <RecommendationItem
              orderItem={item as CartItem}
              addCallback={addCallback}
              itemRank={index + 1}
              onRecommendationClicked={onItemClicked}
            />
          </ItemCol>
        ))}
      </ItemsView>
    </ItemsContainer>
  )
}

export default RecommendationItems
